import React from 'react';

const Codeable = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <path
        fill="#FFB199"
        fillRule="evenodd"
        d="M6.636 6.636L.272 13 13 25.728 25.728 13l-6.364-6.364L13 13z"
      />
    </svg>
  );
};

export default Codeable;
